import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import IBuyerTestimonials from "../components/marketing/IBuyerTestimonials";

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <IBuyerTestimonials />,
    document.getElementById("ibuyer-connect__testimonials")
  );
});
